'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';

import { Question } from '@entities/quiz';
import { Input } from '@shared/ui/components';

import styles from './TextQuestion.module.scss';

interface TextQuestionProps {
  index: number;
  question: Question;
  value: string;
  isPassed: boolean;
  disabled?: boolean;
  isCorrect?: boolean;
  className?: string;
  onChange: (questionId: string, option: string | null, text: string | null) => void;
}

const TextQuestion = memo((props: TextQuestionProps) => {
  const { index, question, value, isPassed, disabled, isCorrect, className, onChange } = props;

  const t = useTranslations('quiz');

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.scope}>
        <div className={styles.question_title}>
          {t('question')} #{index}
        </div>

        <div className={styles.question_text}>{question.text}</div>
      </div>

      <div className={styles.scope}>
        <div className={styles.answer_title}>{t('yourAnswer')}</div>

        <div className={styles.answer_content}>
          <Input
            placeholder="Enter answer"
            value={value}
            disabled={disabled || isPassed || isCorrect}
            lines={1}
            onChange={(v) => onChange(question.id, null, v)}
          />
        </div>

        {isCorrect !== undefined && (
          <div
            className={clsx(styles.result, isCorrect ? styles.result_correct : styles.result_wrong)}
          >
            {t(isCorrect ? 'correctAnswer' : 'wrongAnswer')}
          </div>
        )}
      </div>
    </div>
  );
});

export default TextQuestion;
